import { FormControlLabel, FormHelperText, Switch } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import CoreInputField from "../../../app/core/components/CoreInputField/CoreInputField";
import CoreSelect from "../../../app/core/components/CoreSelect/CoreSelect";
import { CU_MASK, CU_ROW_TYPES } from "../../../utils/constants/cu";
import { actions } from "./singleDocumentSlice";
import { validateFiscalCode } from "../../../utils/functions/form";

const getMaskDefault = () => CU_MASK["default"];

// function getMaskDefault(subCategoryId) {
//   if (CU_MASK[subCategoryId]) {
//     return CU_MASK[subCategoryId];
//   }
//   return [];
// }

function getLabel(value, label) {
  if (value === undefined) {
    return undefined;
  }
  if (typeof value === "number") {
    return label.replace("{YEAR}", value);
  }
  return label.replace(
    "{YEAR}",
    value ? moment(value).year() : moment().year() - 1
  );
}

// eslint-disable-next-line react/prop-types
export function CUInputGroup({
  // disabled,
  document,
  subCategoryId,
  CFMessage,
  fiscalCodes,
  userIsDichCongiunta,
  setCFMessage,
  getMask = getMaskDefault,
  // hideEmptyFields = true,
}) {
  const dispatch = useDispatch();
  const initialCu = {
    annoRiferimento: new Date().getFullYear(),
  };

  const [formData, setFormData] = useState(
    document.cu === null ? initialCu : document.cu
  );

  const [showAllFields, setShowAllFields] = useState(false);

  const handleFormDataChange = (e, key) => {
    const obj = {
      ...formData,
      [key]: e.target.value,
    };
    setFormData(obj);
    dispatch(actions.updateCuForm(obj));
    if (key === "codiceFiscale") {
      const message = validateFiscalCode(
        e.target.value,
        document,
        fiscalCodes,
        userIsDichCongiunta
      );

      setCFMessage(message);
    }
  };

  const hasVisibleFields = (gruppo) => {
    return gruppo.rows.some((rigo) => {
      return formData[rigo.key] !== 0;
    });
  };

  const gruppoCU = (gruppo) => {
    return gruppo.rows.map((rigo) => {
      return (
        ((formData[rigo.key] !== 0 && !showAllFields) || showAllFields) && (
          <div>
            {rigo.type === CU_ROW_TYPES.DATA && (
              <div>
                <CoreInputField
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  key={rigo.key}
                  value={new Date(formData[rigo.key]).getFullYear()}
                  label={rigo.label}
                  onChange={(e) => {
                    return handleFormDataChange(e, rigo.key);
                  }}
                />
                <FormHelperText className="text-red-400">
                  {new Date(formData[rigo.key]).getFullYear() !==
                  new Date(document?.cu?.annoRiferimento)?.getFullYear()
                    ? "Verificare che l'anno di riferimento sia corretto"
                    : null}
                </FormHelperText>
              </div>
            )}
            {rigo.type === CU_ROW_TYPES.CF && (
              <CoreInputField
                className=" me-8"
                InputLabelProps={{ shrink: true }}
                key={rigo.key}
                value={formData[rigo.key]}
                label={rigo.label}
                helperText={
                  <p
                    className={`m-0 ${
                      CFMessage.positive ? "text-green-700" : "text-red-500"
                    }`}
                  >
                    {CFMessage.text.split(",")[0]}
                    <br></br>
                    {CFMessage.text.split(",")[1]}
                  </p>
                }
                color={CFMessage.positive ? "success" : "error"}
                onChange={(e) => {
                  return handleFormDataChange(e, rigo.key);
                }}
              />
            )}
            {rigo.type === CU_ROW_TYPES.IMPORTO && (
              <CoreInputField
                className="me-8"
                InputLabelProps={{ shrink: true }}
                key={rigo.key}
                value={formData[rigo.key]}
                label={rigo.label}
                onChange={(e) => {
                  return handleFormDataChange(e, rigo.key);
                }}
              />
            )}
            {rigo.type === CU_ROW_TYPES.INTERO && (
              <CoreInputField
                className="me-8"
                InputLabelProps={{ shrink: true }}
                key={rigo.key}
                value={formData[rigo.key]}
                label={rigo.label}
                onChange={(e) => {
                  return handleFormDataChange(e, rigo.key);
                }}
              />
            )}
            {rigo.type === CU_ROW_TYPES.TEXT && (
              <CoreInputField
                className="me-8"
                InputLabelProps={{ shrink: true }}
                key={rigo.key}
                value={formData[rigo.key]}
                label={rigo.label}
                onChange={(e) => {
                  return handleFormDataChange(e, rigo.key);
                }}
              />
            )}
            {rigo.type === CU_ROW_TYPES.TEXTAREA && (
              <CoreInputField
                className="me-8"
                InputLabelProps={{ shrink: true }}
                type="textarea"
                key={rigo.key}
                value={formData[rigo.key]}
                onChange={(e) => {
                  return handleFormDataChange(e, rigo.key);
                }}
              />
            )}
            {rigo.type === CU_ROW_TYPES.BOOL && (
              <>
                <FormControlLabel
                  className="me-8"
                  key={rigo.key}
                  value={formData[rigo.key]}
                  control={<Switch color="primary" />}
                  label={rigo.label}
                  labelPlacement="start"
                  onChange={(e) => {
                    return handleFormDataChange(e, rigo.key);
                  }}
                />
              </>
            )}
            {rigo.type === CU_ROW_TYPES.OPTIONS && (
              <div className="mt-6">
                <CoreSelect
                  className="w-48 me-8"
                  label={"Seleziona"}
                  key={rigo.key}
                  value={formData[rigo.key]}
                  onChange={(e) => {
                    return handleFormDataChange(e, rigo.key);
                  }}
                  items={rigo.options}
                />
              </div>
            )}
          </div>
        )
      );
    });
  };

  useEffect(() => {
    dispatch(actions.updateCuForm(formData));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div className="my-4">
        <FormControlLabel
          control={
            <Switch
              checked={showAllFields}
              onChange={() => setShowAllFields(!showAllFields)}
            />
          }
          label="Visualizza tutti i campi"
        />
      </div>
      {showAllFields ? (
        <div>
          {getMask(subCategoryId).map((gruppo) => (
            <>
              <h3>{getLabel(formData["annoRiferimento"], gruppo.label)}</h3>
              <div className="flex flex-wrap w-full">{gruppoCU(gruppo)}</div>
            </>
          ))}
        </div>
      ) : (
        <div>
          {getMask(subCategoryId).map(
            (gruppo) =>
              hasVisibleFields(gruppo) && (
                <>
                  <h3>{getLabel(formData["annoRiferimento"], gruppo.label)}</h3>
                  <div className="flex flex-wrap w-full">
                    {gruppoCU(gruppo)}
                  </div>
                </>
              )
          )}
        </div>
      )}
    </div>
  );
}
